import { TweenLite,TweenMax } from "gsap";

import * as THREE from 'three';
import { Vector3 } from 'three';
var myscene = null;

window.lx = null;
window.collider=null;
//#region  提升机处理
//定义提升机
var tsj_1117 = {
  obj: null,
  ismove: false,
  state: "stop",
  roll_state: "stop",
  box: null,
  cacheBox: null
}
var tsj_1113 = {
  obj: null,
  ismove: false,
  state: "stop",
  roll_state: "stop",
  box: null,
  cacheBox: null
}
var tsj_1109 = {
  obj: null,
  ismove: false,
  state: "stop",
  roll_state: "stop",
  box: null,
  cacheBox: null
}
var tsj_1077 = {
  obj: null,
  ismove: false,
  state: "stop",
  roll_state: "stop",
  box: null,
  cacheBox: null
}

window.dsyzGroup = ["1032_DSYZ_Z1Y2", "1030_DSYZ_Z1Y2", "1022_DSYZ_Z1Y1", "1040_DSYZ_Z1Y2", "1041_DSYZ_Z1Y2", "1049_DSYZ_Z1Y1", "1015_DSYZ_Z1Y1", "1011_DSYZ_Z1Y1", "1071_DSYZ_Z1Y1", "1059_DSYZ_Z1Y2", "1052_DSYZ_Z1Y2", "1052_DSYZ_Z1Y2", "1018_DSYZ_Z1Y1", "1008_DSYZ_Z1Y1", "1006_DSYZ_Z1Y1", "1006_DSYZ_Z1Y1", "1067_DSYZ_Z1Y1", "1062_DSYZ_Z1Y2", "1062_DSYZ_Z1Y2"]
//提升机信息处理
const TSJ_Message_Handle = function (message, tsj_number) {
  var action_info = JSON.parse(message);

  var action_data = action_info.item;
  for (var i = 0; i < action_data.length; i++) {

    if (action_data[i].label == "正转运行" && action_data[i].value == "True") {
      tsj_number.roll_state = "roll_forward";
      if (tsj_number == tsj_1077) {

        if (tsj_number.obj.children[0].position.y < 0.35) {
          if (tsj_number.cacheBox != null) {

            tsj_number.box = tsj_number.cacheBox;
            tsj_number.cacheBox = null;
          }
        }
        if (tsj_number.box != null) {
          if (tsj_number.obj.children[0].position.y > 2.5) {


            myscene.attach(tsj_number.box);
            //console.log(tsj_number.box.parent);
            TweenMax.to(tsj_number.box.position, 4, {
              "x": tsj_number.box.position.x - 1.8, "y": tsj_number.box.position.y, "z": tsj_number.box.position.z, onComplete: function () {

                tsj_number.box = null;


              }
            });
          } else {
            TweenMax.to(tsj_number.box.position, 4, {
              "x": tsj_number.box.position.x - 1.8, "y": tsj_number.box.position.y, "z": tsj_number.box.position.z, onComplete: function () {
                tsj_number.obj.children[0].attach(tsj_number.box);
              }
            });
          }

        }


      } else {
        if (tsj_number.obj.children[1].position.y < 0.35) {
          if (tsj_number.cacheBox != null) {

            tsj_number.box = tsj_number.cacheBox;
            tsj_number.cacheBox = null;
          }
        }
        if (tsj_number.box != null) {
          if (tsj_number.obj.children[1].position.y < 2.5) {

            myscene.attach(tsj_number.box);

            TweenMax.to(tsj_number.box.position, 4, {
              "x": tsj_number.box.position.x, "y": tsj_number.box.position.y, "z": tsj_number.box.position.z + 1.8, onComplete: function () {

                tsj_number.box = null;


              }
            });
          } else {
            TweenMax.to(tsj_number.box.position, 4, {
              "x": tsj_number.box.position.x, "y": tsj_number.box.position.y, "z": tsj_number.box.position.z + 1.8, onComplete: function () {
                tsj_number.obj.children[1].attach(tsj_number.box);
              }
            });
          }

        }
      }



    }
    if (action_data[i].label == "正转运行" && action_data[i].value == "Flase") {
      // tsj_number.roll_state="stop";

    }
    if (action_data[i].label == "反转运行" && action_data[i].value == "True") {
      tsj_number.roll_state = "roll_back";

      if (tsj_number == tsj_1077) {

        if (tsj_number.obj.children[0].position.y < 0.35) {
          if (tsj_number.cacheBox != null) {

            tsj_number.box = tsj_number.cacheBox;
            tsj_number.cacheBox = null;
          }
        }
        if (tsj_number.box != null) {

          myscene.attach(tsj_number.box);
          if (tsj_number.box.parent != "ShenJiang") {
            TweenMax.to(tsj_number.box.position, 3, {
              "x": tsj_number.box.position.x + 1.8, "y": tsj_number.box.position.y, "z": tsj_number.box.position.z, onComplete: function () {

                tsj_number.box = null;


              }
            });
          }



        }


      } else {
        if (tsj_number.obj.children[1].position.y > 2.5) {
          if (tsj_number.cacheBox != null) {

            tsj_number.box = tsj_number.cacheBox;
            tsj_number.cacheBox = null;
          }
        }
        if (tsj_number.box != null) {

          myscene.attach(tsj_number.box);
          if (tsj_number.box.parent != "ShenJiang") {
            TweenMax.to(tsj_number.box.position, 3, {
              "x": tsj_number.box.position.x, "y": tsj_number.box.position.y, "z": tsj_number.box.position.z - 1.8, onComplete: function () {

                tsj_number.box = null;

              }
            });
          }



        }
      }

    }
    if (action_data[i].label == "反转运行" && action_data[i].value == "False") {
      //tsj_number.roll_state="stop";

    }
    if (action_data[i].label == "信息占用" && action_data[i].value == "True") {
      tsj_number.state = "up";


    }
    if (action_data[i].label == "信息占用" && action_data[i].value == "False") {
      tsj_number.state = "down";


    }
    if (action_data[i].label == "输送运行标志位" && action_data[i].value == "True") {
      tsj_number.ismove = true;



    }
    if (action_data[i].label == "输送运行标志位" && action_data[i].value == "False") {
      tsj_number.ismove = false;

    }

  }
}

export { TSJ_Message_Handle }
//提升机信息使用
const TSJ_Message_Handle_ = function (message) {
  var action_info = JSON.parse(message);
  if (action_info.number == 1077) {
    TSJ_Message_Handle(message, tsj_1077);
  }
  if (action_info.number == 1117) {
    TSJ_Message_Handle(message, tsj_1117);
  }
  if (action_info.number == 1113) {
    TSJ_Message_Handle(message, tsj_1113);
  }
  if (action_info.number == 1109) {
    TSJ_Message_Handle(message, tsj_1109);
  }
}
export { TSJ_Message_Handle_ }
//初始化场景设备的位置






//提升机动作处理
const TSJ_Move = function (tsj_number, index) {
  if (tsj_number.obj != null) {
    // console.log(this.tsj_1077_state)
    if (tsj_number.state == "up") {

      if (tsj_number.obj.children[index].position.y > 4.343) {
        tsj_number.state = "stop";
      } else {

       // tsj_number.obj.children[index].position.y += 1 / 90;
       TweenMax.to(tsj_number.obj.children[index].position,10,{"x":tsj_number.obj.children[index].position.x,"y":4.343,"z":tsj_number.obj.children[index].position.z,onComplete:function () {
        
       }})
       tsj_number.state = "stop";
      }
    }
    if (tsj_number.state == "down") {
      if (tsj_number.obj.children[index].position.y < 0.343) {
        tsj_number.state = "stop";
      } else {
        //tsj_number.obj.children[index].position.y -= 1 / 90;
        TweenMax.to(tsj_number.obj.children[index].position,10,{"x":tsj_number.obj.children[index].position.x,"y":0.343,"z":tsj_number.obj.children[index].position.z,onComplete:function () {
         
         }})
         tsj_number.state = "stop";
      }
    }
    if (tsj_number.roll_state == "roll_forward") {
      //正转

      if (tsj_number.box != null) {

        //tsj_number.box.position.x-=0.01;  
      }
    }
    if (tsj_number.roll_state == "roll_back") {
      //反转

      if (tsj_number.box != null) {

        //tsj_number.box.position.x+=0.01;  
      }
    }
  }
}
//提升机动作处理重载
const TSJ_Move_ = function () {
  TSJ_Move(tsj_1077, 0);
  TSJ_Move(tsj_1117, 1);
  TSJ_Move(tsj_1109, 1);
  TSJ_Move(tsj_1113, 1);
}

export { TSJ_Move_ }
//#endregion
//#region 夹抱机处理
//定义夹抱机
var jbj_1074 = {
  obj: null,
  ismove: false,
  state: "stop",
  box: null

}
var jbj_1004 = {
  obj: null,
  ismove: false,
  state: "stop",
  box: null

}
//夹抱机信息处理
const JBJ_handle = function (message) {

  var action_info = JSON.parse(message);
  //   var jbj_1004=this.scene.getObjectByName("1004_JBJ");
  //   var whole=jbj_1004.children[0].children[0];
  // // whole.position.set(1.8,whole.position.y,whole.position.z);
  //   var left=whole.children[0];
  //   var right=whole.children[1];

  if (action_info.number == 1004) {
    // console.log(action_info)
    var action_data = action_info.item;


    for (var i = 0; i < action_data.length; i++) {
      //console.log(action_data[i].label+action_data[i].value);
      if (action_data[i].label == "下降运行" && action_data[i].value == "True") {

        jbj_1004.state = "down";
        TweenMax.to(jbj_1004.obj.children[0].children[0].position, 2, {
          "x": jbj_1004.obj.children[0].children[0].position.x, "y": -1.208, "z": jbj_1004.obj.children[0].children[0].position.z, onComplete: function () {
            TweenMax.to(jbj_1004.obj.children[0].children[0].children[0].position, 2, { "x": jbj_1004.obj.children[0].children[0].children[0].position.x, "y": jbj_1004.obj.children[0].children[0].children[0].position.y, "z": jbj_1004.obj.children[0].children[0].children[0].position.z - 0.12 });
            TweenMax.to(jbj_1004.obj.children[0].children[0].children[1].position, 2, {
              "x": jbj_1004.obj.children[0].children[0].children[1].position.x, "y": jbj_1004.obj.children[0].children[0].children[1].position.y, "z": jbj_1004.obj.children[0].children[0].children[1].position.z + 0.12, onComplete: function () {


                if (jbj_1004.box != null) {

                  if (jbj_1004.box.parent == jbj_1004.obj.children[0].children[0]) {

                    myscene.attach(jbj_1004.box);
                    var e = window.lx.clone();
                    myscene.add(e);
                    
                    e.position.set(-17.88, 1.569, -1.531);
                    e.name="liaoxiang";
                    window.collider.init(e);

                    myscene.remove(jbj_1004.box)
                    
                    ss_1006_box = e;
                    jbj_1004.box = null;
                  }

                }
              }
            });
          }
        });
        // console.log("下降运行")

      } if (action_data[i].label == "下降运行" && action_data[i].value == "False") {
        //this.jbj_1074_state="stop";
      }
      if (action_data[i].label == "上升运行" && action_data[i].value == "True") {

        jbj_1004.state = "up";
        // console.log("上升运行")
      } if (action_data[i].label == "上升运行" && action_data[i].value == "False") {
        //this.jbj_1074_state="stop";
      }
      if (action_data[i].label == "后退运行" && action_data[i].value == "True") {

        jbj_1004.state = "back";
        //console.log("后退运行")
        TweenMax.to(jbj_1004.obj.children[0].children[0].position, 5, {
          "x": 0.054, "y": jbj_1004.obj.children[0].children[0].position.y, "z": jbj_1004.obj.children[0].children[0].position.z, onComplete: function () {
            TweenMax.to(jbj_1004.obj.children[0].children[0].children[0].position, 2, { "x": jbj_1004.obj.children[0].children[0].children[0].position.x, "y": jbj_1004.obj.children[0].children[0].children[0].position.y, "z": jbj_1004.obj.children[0].children[0].children[0].position.z + 0.12 });
            TweenMax.to(jbj_1004.obj.children[0].children[0].children[1].position, 2, {
              "x": jbj_1004.obj.children[0].children[0].children[1].position.x, "y": jbj_1004.obj.children[0].children[0].children[1].position.y, "z": jbj_1004.obj.children[0].children[0].children[1].position.z - 0.12, onComplete: function () {
                if (jbj_1004.cacheBox != null) {
                  jbj_1004.box = jbj_1004.cacheBox;
                  jbj_1004.box.name = "liaoxiang";
                  jbj_1004.cacheBox = null;
                }
                if (jbj_1004.box != null) {
                  jbj_1004.obj.children[0].children[0].attach(jbj_1004.box);
                }
                TweenMax.to(jbj_1004.obj.children[0].children[0].position, 3, {
                  "x": jbj_1004.obj.children[0].children[0].position.z, "y": -0.848, "z": jbj_1004.obj.children[0].children[0].position.z, onComplete: function () {
                    TweenMax.to(jbj_1004.obj.children[0].children[0].position, 5, {
                      "x": 1.862, "y": jbj_1004.obj.children[0].children[0].position.y, "z": jbj_1004.obj.children[0].children[0].position.z, onComplete: function () {

                      }
                    })
                  }
                })
              }
            });
          }
        })
      } if (action_data[i].label == "后退运行" && action_data[i].value == "False") {
        // this.jbj_1074_state="stop";
      }
      if (action_data[i].label == "前进运行" && action_data[i].value == "True") {
        //console.log("前进运行")
        jbj_1004.state = "forward";
      } if (action_data[i].label == "前进运行" && action_data[i].value == "False") {
        //this.jbj_1074_state="stop";
      }
      if (action_data[i].label == "张开动作" && action_data[i].value == "True") {
        jbj_1004.state = "zhang";
        //console.log("张开动作")


      }
      if (action_data[i].label == "张开动作" && action_data[i].value == "False") {
        // this.jbj_1074_state="stop";

      }
      if (action_data[i].label == "夹紧气缸动作点位" && action_data[i].value == "True") {
        jbj_1004.state = "jia";

        //console.log("夹紧气缸动作点位"+action_info.time);
      }
      if (action_data[i].label == "夹紧气缸动作点位" && action_data[i].value == "False") {
        //this.jbj_1074_state="stop";

      }
      if (action_data[i].label == "设备运行标志位" && action_data[i].value == "True") {
        jbj_1004.ismove = true;

      }
      if (action_data[i].label == "设备运行标志位" && action_data[i].value == "False") {
        jbj_1004.ismove = false;

      }

    }
  }
  if (action_info.number == 1074) {
    var action_data = action_info.item;
    //console.log(action_info)

    for (var i = 0; i < action_data.length; i++) {
      //console.log(action_data[i].label+action_data[i].value);
      if (action_data[i].label == "下降运行" && action_data[i].value == "True") {
        //结束标志
        jbj_1074.state = "down";
        //console.log("下降运行")
        TweenMax.to(jbj_1074.obj.children[2].children[0].position, 2, {
          "x": jbj_1074.obj.children[2].children[0].position.x, "y": -1.3, "z": jbj_1074.obj.children[2].children[0].position.z, onComplete: function () {
            if (jbj_1074.box != null) {
              myscene.attach(jbj_1074.box);
              jbj_1074.box.children[0].position=new Vector3(0,0,0)
              
            }
            TweenMax.to(jbj_1074.obj.children[2].children[0].children[0].position, 2, { "x": jbj_1074.obj.children[2].children[0].children[0].position.x, "y": jbj_1074.obj.children[2].children[0].children[0].position.y, "z": jbj_1074.obj.children[2].children[0].children[0].position.z - 0.12 });
            TweenMax.to(jbj_1074.obj.children[2].children[0].children[1].position, 2, {
              "x": jbj_1074.obj.children[2].children[0].children[1].position.x, "y": jbj_1074.obj.children[2].children[0].children[1].position.y, "z": jbj_1074.obj.children[2].children[0].children[1].position.z + 0.12, onComplete: function () {
                TweenMax.to(jbj_1074.obj.children[2].children[0].position, 5, { "x": 1.921, "y": jbj_1074.obj.children[2].children[0].position.y, "z": jbj_1074.obj.children[2].children[0].position.z });
              }
            });
          }
        })

        //TweenMax.to(jbj_1074.obj.children[2].children[0].position,3,{"x":children[2].children[0].position.x,"y":-1.3,"z":children[2].children[0].position.z});

      } if (action_data[i].label == "下降运行" && action_data[i].value == "False") {
        //this.jbj_1074_state="stop";
      }
      if (action_data[i].label == "上升运行" && action_data[i].value == "True") {

        jbj_1074.state = "up";

        //console.log("上升运行")
      } if (action_data[i].label == "上升运行" && action_data[i].value == "False") {
        //this.jbj_1074_state="stop";
      }
      if (action_data[i].label == "后退运行" && action_data[i].value == "True") {

        jbj_1074.state = "back";
        // console.log("后退运行")
      } if (action_data[i].label == "后退运行" && action_data[i].value == "False") {
        // this.jbj_1074_state="stop";
        if (jbj_1074.box != null) {
          myscene.attach(jbj_1074.box);
          jbj_1074.box = null;
        }
      }
      if (action_data[i].label == "前进运行" && action_data[i].value == "True") {

        jbj_1074.state = "forward";
        //console.log("前进运行")
      } if (action_data[i].label == "前进运行" && action_data[i].value == "False") {
        //this.jbj_1074_state="stop";
      }
      if (action_data[i].label == "张开动作" && action_data[i].value == "True") {
        jbj_1074.state = "zhang";
        // if(jbj_1074.box!=null){
        //     myscene.attach(jbj_1074.box);
        //     jbj_1074.box=null;
        // }
        //console.log("张开动作")

      }
      if (action_data[i].label == "张开动作" && action_data[i].value == "False") {
        // this.jbj_1074_state="stop";

      }
      if (action_data[i].label == "夹紧气缸动作点位" && action_data[i].value == "True") {
        //开始动作
        jbj_1074.state = "jia";
        //console.log("夹紧气缸动作点位")



        TweenMax.to(jbj_1074.obj.children[2].children[0].children[0].position, 2, { "x": jbj_1074.obj.children[2].children[0].children[0].position.x, "y": jbj_1074.obj.children[2].children[0].children[0].position.y, "z": jbj_1074.obj.children[2].children[0].children[0].position.z + 0.12 });
        TweenMax.to(jbj_1074.obj.children[2].children[0].children[1].position, 2, {
          "x": jbj_1074.obj.children[2].children[0].children[1].position.x, "y": jbj_1074.obj.children[2].children[0].children[1].position.y, "z": jbj_1074.obj.children[2].children[0].children[1].position.z - 0.12, onComplete: function () {
            if (jbj_1074.cacheBox != null) {
              jbj_1074.box = jbj_1074.cacheBox;
              var tp_empty = jbj_1074.box.children[0];
              myscene.attach(tp_empty)
              TweenMax.to(tp_empty.position, 10, { "x": tp_empty.position.x, "y": tp_empty.position.y, "z": tp_empty.position.z - 3.3, delay: 2 })
              jbj_1074.cacheBox = null;
            }
            if (jbj_1074.box != null) {
              jbj_1074.obj.children[2].children[0].attach(jbj_1074.box);
            }
            TweenMax.to(jbj_1074.obj.children[2].children[0].position, 3, {
              "x": jbj_1074.obj.children[2].children[0].position.x, "y": -0.95, "z": jbj_1074.obj.children[2].children[0].position.z, onComplete: function () {
                TweenMax.to(jbj_1074.obj.children[2].children[0].position, 7, {
                  "x": 0.45, "y": jbj_1074.obj.children[2].children[0].position.y, "z": jbj_1074.obj.children[2].children[0].position.z, onComplete: function () {
                    //准备下降
                  }
                })
              }
            })
          }
        });

        //console.log("1074箱子"+jbj_1074.box);
        // if(jbj_1074.cacheBox!=null){
        //     jbj_1074.box=jbj_1074.cacheBox;
        //     jbj_1074.cacheBox=null;
        // }
        // if(jbj_1074.box!=null){

        //   jbj_1074.obj.children[2].children[0].attach(jbj_1074.box);

        // }

      }
      if (action_data[i].label == "夹紧气缸动作点位" && action_data[i].value == "False") {
        //this.jbj_1074_state="stop";

      }
      if (action_data[i].label == "设备运行标志位" && action_data[i].value == "True") {
        jbj_1074.ismove = true;

      }
      if (action_data[i].label == "设备运行标志位" && action_data[i].value == "False") {
        jbj_1074.ismove = false;

      }

    }
  }


}
export { JBJ_handle }
var shusong_1001 = {
  box: null,
  cacheBox: null,
}
const JBJ_action = function () {
  // if(jbj_1074.obj!=null){
  //     if(jbj_1074.ismove==true){

  //         if(jbj_1074.state=="down"){
  //             if(jbj_1074.obj.children[2].children[0].position.y<-1.3){
  //               jbj_1074.state="stop";
  //             }else{
  //               jbj_1074.obj.children[2].children[0].position.y-=0.35/180;
  //             }
  //           }
  //           if(jbj_1074.state=="up"){
  //             if(jbj_1074.obj.children[2].children[0].position.y>-0.95){
  //               jbj_1074.state="stop";
  //             }else{
  //               if(jbj_1074.obj.children[2].children[0].position.x>1.3){
  //                 jbj_1074.obj.children[2].children[0].position.y+=0.35/180;
  //               }

  //             }
  //           }
  //             if(jbj_1074.state=="forward"){

  //                   if(jbj_1074.obj.children[2].children[0].position.x<0.45){
  //                       jbj_1074.state="stop";
  //                     }else{                         
  //                           jbj_1074.obj.children[2].children[0].position.x-=(1.921-0.45)/300;                                                    
  //                     }


  //           }
  //              if(jbj_1074.state=="back"){
  //             if(jbj_1074.obj.children[2].children[0].position.x>1.921){
  //               jbj_1074.state="stop";
  //             }else{
  //               jbj_1074.obj.children[2].children[0].position.x+=(1.921-0.45)/300;
  //             }
  //           }
  //     }


  //       if(jbj_1074.state=="zhang"){

  //       if(jbj_1074.obj.children[2].children[0].children[0].position.z<-0.665){
  //         jbj_1074.state=stop;
  //       }else{
  //         jbj_1074.obj.children[2].children[0].children[0].position.z-=0.14/120;
  //         jbj_1074.obj.children[2].children[0].children[1].position.z+=0.12/120;
  //       }
  //     }
  //        if(jbj_1074.state=="jia"){
  //       if(jbj_1074.obj.children[2].children[0].children[0].position.z>-0.52){
  //         jbj_1074.state=stop;
  //       }else{
  //         jbj_1074.obj.children[2].children[0].children[0].position.z+=0.14/120;
  //         jbj_1074.obj.children[2].children[0].children[1].position.z-=0.12/120;
  //       }
  //     }
  //     //this.jbj_1074.children[2].children[0].position
  //   }
  if (jbj_1004.obj != null) {

    if (jbj_1004.ismove == true) {
      if (jbj_1004.state == "down") {
        if (jbj_1004.obj.children[0].children[0].position.y < -1.208) {
          jbj_1004.state = "stop";
        } else {
          jbj_1004.obj.children[0].children[0].position.y -= (1.208 - 0.848) / 180;
        }
      }
      if (jbj_1004.state == "up") {
        if (jbj_1004.obj.children[0].children[0].position.y > -0.848) {
          jbj_1004.state = "stop";
        } else {
          if (jbj_1004.obj.children[0].children[0].position.x < 1.3) {
            jbj_1004.obj.children[0].children[0].position.y += (1.208 - 0.848) / 180;
          }

        }
      }
      if (jbj_1004.state == "forward") {
        if (jbj_1004.obj.children[0].children[0].position.x > 1.862) {
          jbj_1004.state = "stop";
        } else {
          jbj_1004.obj.children[0].children[0].position.x += (1.862 - 0.195) / 180;
        }
      }
      if (jbj_1004.state == "back") {
        if (jbj_1004.obj.children[0].children[0].position.x < 0.054) {
          jbj_1004.state = "stop";
        } else {
          jbj_1004.obj.children[0].children[0].position.x -= (1.862 - 0.054) / 180;
        }
      }
    }

    if (jbj_1004.state == "zhang") {
      if (jbj_1004.obj.children[0].children[0].children[0].position.z < -0.787) {
        jbj_1004.state = "stop";
      } else {
        jbj_1004.obj.children[0].children[0].children[0].position.z -= 0.14 / 120;
        jbj_1004.obj.children[0].children[0].children[1].position.z += 0.12 / 120;
      }
    }
    if (jbj_1004.state == "jia") {
      if (jbj_1004.obj.children[0].children[0].children[0].position.z > -0.553) {
        jbj_1004.state = stop;
      } else {
        jbj_1004.obj.children[0].children[0].children[0].position.z += 0.22 / 120;
        jbj_1004.obj.children[0].children[0].children[1].position.z -= 0.12 / 120;
      }
    }
  }
}
export { JBJ_action }
//#endregion

//#region 拆垛机处理

var cdj_1002 = {
  obj: null,
  state: "stop",
  ismove: false,
  upSpeed_1002: null,
  downSpeed_1002: null,
  box: null

}
var double_box = null;

const Destroy_Error_box = function () {
  if (cdj_1002.cacheBox != null) {
    myscene.remove(cdj_1002.cacheBox);
    cdj_1002.cacheBox = null;
    cdj_1002.box = null;

  }
}
export { Destroy_Error_box }
var shusong1003 = {
  box: null,
  cacheBox: null
}
const box_1003_move = function (message) {

  if (message.number == 1001) {
    var action_data = message.item;
    for (var i = 0; i < action_data.length; i++) {
      if (action_data[i].label == "1001烟包组就绪" && action_data[i].value == "True") {
        //     var box=double_box.clone();
        //     box.position.set(-22.5,1.5,-1.494);

        //     myscene.add(box);
        //    //console.log("1056生成箱子")
        //    SetBox("1002",box);
        
        if (cdj_1002.cacheBox != null && cdj_1002.obj.children[0].children[1].position.z != -0.489) {
          // TweenMax.to(cdj_1002.obj.children[0].children[1].position,1,{"x":cdj_1002.obj.children[0].children[1].position.x,"y":cdj_1002.obj.children[0].children[1].position.y,"z":-0.489});


          // TweenMax.to(cdj_1002.obj.children[0].children[0].position,1,{"x":cdj_1002.obj.children[0].children[0].position.x,"y":cdj_1002.obj.children[0].children[0].position.y,"z":0.58,onComplete:function () {


          //     if(cdj_1002.box!=null){
          //         cdj_1002.obj.children[0].attach(cdj_1002.box);
          //     }
          //     //箱子走测试
          //     // TweenMax.to(cdj_1002.cacheBox.position,8,{"x":-19.7,"y":cdj_1002.cacheBox.position.y,"z":cdj_1002.cacheBox.position.z,dealy:1,onComplete:function () {
          //     //     SetBox("1004",cdj_1002.cacheBox)

          //     // }})
          //     // cdj_1002.cacheBox=null;
          //     //夹住上升
          //     shusong_1001.box=cdj_1002.cacheBox;
          //     TweenMax.to(cdj_1002.obj.children[0].position,4,{"x":cdj_1002.obj.children[0].position.x,"y":2.1,"z":cdj_1002.obj.children[0].position.z,onComplete:function () {

          //     }})
          // }})
        }

      }

      if (action_data[i].label == "1001允许拆包机放烟" && action_data[i].value == "True") {
       // console.log("1001允许拆包机放烟" + message.time)
        // if(cdj_1002.box!=null){
        //     if(cdj_1002.box.parent==cdj_1002.obj.children[0]){
        //         TweenMax.to(cdj_1002.obj.children[0].position,6,{"x":cdj_1002.obj.children[0].position.x,"y":1.163,"z":cdj_1002.obj.children[0].position.z,onComplete:function () {
        //             TweenMax.to(cdj_1002.obj.children[0].children[1].position,1,{"x":cdj_1002.obj.children[0].children[1].position.x,"y":cdj_1002.obj.children[0].children[1].position.y,"z":-0.676});
        //             TweenMax.to(cdj_1002.obj.children[0].children[0].position,1,{"x":cdj_1002.obj.children[0].children[0].position.x,"y":cdj_1002.obj.children[0].children[0].position.y,"z":0.724,onComplete:function () {
        //                 myscene.attach( cdj_1002.box);
        //                 shusong_1001.cacheBox=cdj_1002.box;
        //                 cdj_1002.box=null;
        //                 cdj_1002.cacheBox=null;
        //                 TweenMax.to(cdj_1002.obj.children[0].position,4,{"x":cdj_1002.obj.children[0].position.x,"y":2.1,"z":cdj_1002.obj.children[0].position.z,onComplete:function () {
        //                    TweenMax.to(cdj_1002.obj.children[0].position,2,{"x":cdj_1002.obj.children[0].position.x,"y":1.825,"z":cdj_1002.obj.children[0].position.z})
        //                 }})
        //             }});

        //         }})
        //     }
        // }

      }
      if (action_data[i].label == "1001站台出货" && action_data[i].value == "True") {
        //console.log("1001站台出货" + message.time)
        if (shusong_1001.box != null) {
          TweenMax.to(shusong_1001.box.position, 7, {
            "x": -21, "y": shusong_1001.box.position.y, "z": shusong_1001.box.position.z, onComplete: function () {
              // if(jbj_1004.box!=null&&jbj_1004.box.parent!=jbj_1004.obj.children[0].children[0]){
              //     myscene.remove(jbj_1004.box);
              //     jbj_1004.box=null;
              // }
              //SetBox("1004",shusong_1001.box)
              shusong1003.box = shusong_1001.box;
              shusong_1001.box = null;
            }
          })
        }
      }

      if (action_data[i].label == "1001站台接货" && action_data[i].value == "True") {
        //console.log("1001站台接货" + message.time)
      }

    }


  }

  if (message.number == 1003) {
    var action_data = message.item;
    for (var i = 0; i < action_data.length; i++) {
      if (action_data[i].label == "正转运行" && action_data[i].value == "True") {
        //console.log("1003正转运行")
        if (shusong1003.box != null) {
          var bb = shusong1003.box;
          TweenMax.to(bb.position, 6, {
            "x": -19.7, "y": bb.position.y, "z": bb.position.z, onComplete: function () {
              if (jbj_1004.box != null && jbj_1004.box.parent != jbj_1004.obj.children[0].children[0]) {
                myscene.remove(jbj_1004.box);
                jbj_1004.box = null;
              }
              SetBox("1004", bb);

              bb = null;
            }
          })
          shusong1003.box = null;
        }

      }

    }
  }

}
export { box_1003_move }

const MPJ_Handle = function (message) {
  // var action_data=message.item;
  // for(var i=0;i<action_data.length;i++){
  //     if(action_data[i].label=="托盘数量"){
  //         var num=parsenInt(action_data[i].value);
  //         //生成托盘

  //     }   
  // }
}
export { MPJ_Handle }
const CDJ_Error_Handle = function (message) {
  var action_data = message.item;

  if (cdj_1002.cacheBox != null) {
    TweenMax.to(cdj_1002.cacheBox.position, 3, {
      "x": -22.8, "y": cdj_1002.cacheBox.position.y, "z": cdj_1002.cacheBox.position.z, delay: 1, onComplete: function () {
        TweenMax.to(cdj_1002.obj.children[0].children[1].position, 1, { "x": cdj_1002.obj.children[0].children[1].position.x, "y": cdj_1002.obj.children[0].children[1].position.y, "z": -0.489 });


        TweenMax.to(cdj_1002.obj.children[0].children[0].position, 1, {
          "x": cdj_1002.obj.children[0].children[0].position.x, "y": cdj_1002.obj.children[0].children[0].position.y, "z": 0.58, onComplete: function () {


            if (cdj_1002.box != null) {
              cdj_1002.obj.children[0].attach(cdj_1002.box);
            }

            TweenMax.to(cdj_1002.obj.children[0].position, 4, {
              "x": cdj_1002.obj.children[0].position.x, "y": 2.1, "z": cdj_1002.obj.children[0].position.z, onComplete: function () {
                if (cdj_1002.box != null) {
                  if (cdj_1002.box.parent == cdj_1002.obj.children[0]) {
                    TweenMax.to(cdj_1002.obj.children[0].position, 6, {
                      "x": cdj_1002.obj.children[0].position.x, "y": 1.163, "z": cdj_1002.obj.children[0].position.z, delay: 6, onComplete: function () {
                        TweenMax.to(cdj_1002.obj.children[0].children[1].position, 1, { "x": cdj_1002.obj.children[0].children[1].position.x, "y": cdj_1002.obj.children[0].children[1].position.y, "z": -0.676 });
                        TweenMax.to(cdj_1002.obj.children[0].children[0].position, 1, {
                          "x": cdj_1002.obj.children[0].children[0].position.x, "y": cdj_1002.obj.children[0].children[0].position.y, "z": 0.724, onComplete: function () {
                            myscene.attach(cdj_1002.box);



                            TweenMax.to(cdj_1002.obj.children[0].position, 4, {
                              "x": cdj_1002.obj.children[0].position.x, "y": 2.1, "z": cdj_1002.obj.children[0].position.z, onComplete: function () {
                                TweenMax.to(cdj_1002.obj.children[0].position, 2, { "x": cdj_1002.obj.children[0].position.x, "y": 1.825, "z": cdj_1002.obj.children[0].position.z })
                              }
                            })
                          }
                        });

                      }
                    })
                  }
                }
              }
            })
          }
        })

      }
    });
  }



}
export { CDJ_Error_Handle }
const InitBox = function (box_prefab) {
  double_box = box_prefab;

}

export { InitBox }
var timer = 0;
const Handle_error = function () {
  if (jbj_1004.box != null) {
    timer += 1 / 60;
    if (timer > 15) {
      //console.log("该移除这个箱子")
      myscene.remove(jbj_1004.box)
      jbj_1004.box = null;

      timer = 0;

    }

  }
}
export { Handle_error }
const CDJ_task_handle = function (message) {
  var action_info = JSON.parse(message);
  var action_data = action_info.item;
  for (var i = 0; i < action_data.length; i++) {
    if (action_data[i].label == "任务号") {
      TweenMax.to(cdj_1002.obj.children[0].children[1].position, 0.8, { "x": cdj_1002.obj.children[0].children[1].position.x, "y": cdj_1002.obj.children[0].children[1].position.y, "z": -0.630 });
      TweenMax.to(cdj_1002.obj.children[0].children[0].position, 0.8, {
        "x": cdj_1002.obj.children[0].children[0].position.x, "y": cdj_1002.obj.children[0].children[0].position.y, "z": 0.673, onComplete: function () {
          if (cdj_1002.box != null) {
            cdj_1002.obj.children[0].attach(cdj_1002.box);
            shusong_1001.box = cdj_1002.cacheBox;
            TweenMax.to(cdj_1002.obj.children[0].position, 4.5, {
              "x": cdj_1002.obj.children[0].position.x, "y": 2.1, "z": cdj_1002.obj.children[0].position.z, delay: 1.8, onComplete: function () {

                TweenMax.to(cdj_1002.obj.children[0].position, 6.8, {
                  "x": cdj_1002.obj.children[0].position.x, "y": 1.163, "z": cdj_1002.obj.children[0].position.z, delay: 10, onComplete: function () {

                    TweenMax.to(cdj_1002.obj.children[0].children[1].position, 0.8, { "x": cdj_1002.obj.children[0].children[1].position.x, "y": cdj_1002.obj.children[0].children[1].position.y, "z": -0.676 });
                    TweenMax.to(cdj_1002.obj.children[0].children[0].position, 0.8, {
                      "x": cdj_1002.obj.children[0].children[0].position.x, "y": cdj_1002.obj.children[0].children[0].position.y, "z": 0.724, onComplete: function () {

                        myscene.attach(cdj_1002.box);
                        shusong_1001.box = cdj_1002.box;
                        cdj_1002.box = null;
                        cdj_1002.cacheBox = null;
                        TweenMax.to(cdj_1002.obj.children[0].position, 6, {
                          "x": cdj_1002.obj.children[0].position.x, "y": 2.1, "z": cdj_1002.obj.children[0].position.z, delay: 1.8, delay: 0.5, onComplete: function () {

                            TweenMax.to(cdj_1002.obj.children[0].position, 3, { "x": cdj_1002.obj.children[0].position.x, "y": 1.825, "z": cdj_1002.obj.children[0].position.z })

                          }
                        });

                      }
                    });
                  }
                });
              }
            })

          }


        }
      });
    }
  }
}
export { CDJ_task_handle }
const CDJ_handle = function (message) {

  var action_info = JSON.parse(message);
  if (action_info.number == 1002) {
    //console.log(action_info);

    var action_data = action_info.item;
    //console.log(action_info)

    for (var i = 0; i < action_data.length; i++) {
      //console.log(action_data[i].label+action_data[i].value);
      if (action_data[i].label == "下降运行" && action_data[i].value == "True") {

        cdj_1002.state = "down";
        //console.log("下降运行")
       // console.log("1002箱子" + cdj_1002.box)

        //    if(cdj_1002.box!=null){
        //     if(cdj_1002.box.parent==cdj_1002.obj.children[0]){
        //         TweenMax.to(cdj_1002.obj.children[0].position,6,{"x":cdj_1002.obj.children[0].position.x,"y":1.163,"z":cdj_1002.obj.children[0].position.z,onComplete:function () {
        //             TweenMax.to(cdj_1002.obj.children[0].children[1].position,1,{"x":cdj_1002.obj.children[0].children[1].position.x,"y":cdj_1002.obj.children[0].children[1].position.y,"z":-0.676});
        //             TweenMax.to(cdj_1002.obj.children[0].children[0].position,1,{"x":cdj_1002.obj.children[0].children[0].position.x,"y":cdj_1002.obj.children[0].children[0].position.y,"z":0.724,onComplete:function () {
        //                 myscene.attach( cdj_1002.box);
        //                 shusong_1001.cacheBox=cdj_1002.box;
        //                 cdj_1002.box=null;
        //                 cdj_1002.cacheBox=null;
        //                 TweenMax.to(cdj_1002.obj.children[0].position,4,{"x":cdj_1002.obj.children[0].position.x,"y":2.1,"z":cdj_1002.obj.children[0].position.z,onComplete:function () {
        //                    TweenMax.to(cdj_1002.obj.children[0].position,2,{"x":cdj_1002.obj.children[0].position.x,"y":1.825,"z":cdj_1002.obj.children[0].position.z})
        //                 }})
        //             }});

        //         }})
        //     }
        // }




      } if (action_data[i].label == "下降运行" && action_data[i].value == "False") {
        // cdj_1002.state="stop";
      }
      if (action_data[i].label == "上升运行" && action_data[i].value == "True") {

        cdj_1002.state = "up";
        //console.log("上升运行")
      } if (action_data[i].label == "上升运行" && action_data[i].value == "False") {
        //cdj_1002.state="stop";
      }

      if (action_data[i].label == "张开动作" && action_data[i].value == "True") {
        cdj_1002.state = "zhang";
        //console.log("张开动作")
        cdj_1002.upSpeed_1002 = 0.1825;
        cdj_1002.downSpeed_1002 = 0.066;

      }
      if (action_data[i].label == "张开动作" && action_data[i].value == "False") {
        // this.jbj_1074_state="stop";

      }
      if (action_data[i].label == "夹紧气缸动作点位" && action_data[i].value == "True") {
        console.log("夹紧气缸动作点位")
        TweenMax.to(cdj_1002.obj.children[0].children[1].position, 0.8, { "x": cdj_1002.obj.children[0].children[1].position.x, "y": cdj_1002.obj.children[0].children[1].position.y, "z": -0.630 });
        TweenMax.to(cdj_1002.obj.children[0].children[0].position, 0.8, {
          "x": cdj_1002.obj.children[0].children[0].position.x, "y": cdj_1002.obj.children[0].children[0].position.y, "z": 0.673, onComplete: function () {
            
            if (cdj_1002.box!= null) {
            
              cdj_1002.obj.children[0].attach(cdj_1002.box);
              shusong_1001.box = cdj_1002.cacheBox;
              
              TweenMax.to(cdj_1002.obj.children[0].position, 4.5, {
                "x": cdj_1002.obj.children[0].position.x, "y": 2.1, "z": cdj_1002.obj.children[0].position.z, delay: 1.8, onComplete: function () {

                  TweenMax.to(cdj_1002.obj.children[0].position, 6.8, {
                    "x": cdj_1002.obj.children[0].position.x, "y": 1.163, "z": cdj_1002.obj.children[0].position.z, delay: 10, onComplete: function () {

                      TweenMax.to(cdj_1002.obj.children[0].children[1].position, 0.8, { "x": cdj_1002.obj.children[0].children[1].position.x, "y": cdj_1002.obj.children[0].children[1].position.y, "z": -0.676 });
                      TweenMax.to(cdj_1002.obj.children[0].children[0].position, 0.8, {
                        "x": cdj_1002.obj.children[0].children[0].position.x, "y": cdj_1002.obj.children[0].children[0].position.y, "z": 0.724, onComplete: function () {
                            if(cdj_1002.box){
                              
                              myscene.attach(cdj_1002.box);
                            }
                          
                          shusong_1001.box = cdj_1002.box;
                          cdj_1002.box = null;
                          cdj_1002.cacheBox = null;
                          TweenMax.to(cdj_1002.obj.children[0].position, 6, {
                            "x": cdj_1002.obj.children[0].position.x, "y": 2.1, "z": cdj_1002.obj.children[0].position.z, delay: 1.8, delay: 0.5, onComplete: function () {

                              TweenMax.to(cdj_1002.obj.children[0].position, 3, { "x": cdj_1002.obj.children[0].position.x, "y": 1.825, "z": cdj_1002.obj.children[0].position.z })

                            }
                          });

                        }
                      });
                    }
                  });
                }
              })

            }


          }
        });
        // TweenMax.to(cdj_1002.obj.children[0].children[1].position,2,{"x":cdj_1002.obj.children[0].children[1].position.x,"y":cdj_1002.obj.children[0].children[1].position.y,"z":cdj_1002.obj.children[0].children[1].position.z+0.12});


        // TweenMax.to(cdj_1002.obj.children[0].children[0].position,2,{"x":cdj_1002.obj.children[0].children[0].position.x,"y":cdj_1002.obj.children[0].children[0].position.y,"z":cdj_1002.obj.children[0].children[0].position.z-0.18,onComplete:function () {


        //     if(cdj_1002.box!=null){
        //         cdj_1002.obj.children[0].attach(cdj_1002.box);
        //     }
        //     TweenMax.to(cdj_1002.cacheBox.position,10,{"x":-20.3,"y":cdj_1002.cacheBox.position.y,"z":cdj_1002.cacheBox.position.z})
        //     TweenMax.to(cdj_1002.obj.children[0].position,3,{"x":cdj_1002.obj.children[0].position.x,"y":2.1,"z":cdj_1002.obj.children[0].position.z})
        // }})
        cdj_1002.state = "jia";
        cdj_1002.upSpeed_1002 = 0.0425;
        cdj_1002.downSpeed_1002 = 0.129;

      }
      if (action_data[i].label == "夹紧气缸动作点位" && action_data[i].value == "False") {
        //this.jbj_1074_state="stop";

      }
      if (action_data[i].label == "运行标志位" && action_data[i].value == "True") {
        cdj_1002.ismove = true;

      }
      if (action_data[i].label == "运行标志位" && action_data[i].value == "False") {
        cdj_1002.ismove = false;

      }

    }
  }
}
export { CDJ_handle }

const CDJ_action = function () {
  if (cdj_1002.obj != null) {
    if (cdj_1002.ismove == true) {
      if (cdj_1002.state == "down") {
        if (cdj_1002.obj.children[0].position.y < 1.163) {
          cdj_1002.state = "stop";
        } else {

          cdj_1002.obj.children[0].position.y -= cdj_1002.downSpeed_1002 / 60;


        }
      }
      if (cdj_1002.state == "up") {
        if (cdj_1002.obj.children[0].position.y > 2.1) {
          cdj_1002.state = "stop";
        } else {

          cdj_1002.obj.children[0].position.y += cdj_1002.upSpeed_1002 / 60;




        }
      }


    }

    if (cdj_1002.state == "zhang") {
      if (cdj_1002.obj.children[0].children[0].position.z > 0.724) {
        cdj_1002.state = "stop";
      } else {
        cdj_1002.obj.children[0].children[0].position.z += 0.14 / 120;
        cdj_1002.obj.children[0].children[1].position.z -= 0.12 / 120;
      }
    }
    if (cdj_1002.state == "jia") {
      if (cdj_1002.obj.children[0].children[0].position.z < 0.55) {
        cdj_1002.state = "stop";
      } else {
        cdj_1002.obj.children[0].children[0].position.z -= 0.18 / 120;
        cdj_1002.obj.children[0].children[1].position.z += 0.12 / 120;
      }
    }
  }
}

export { CDJ_action }
//#endregion
var shusong1046 = {
  pos: null,
  box: null,
  cacheBox: null,
}
const Init_Device_pos = function (scene) {
  tsj_1077.obj = scene.getObjectByName("1077_TSJ");
  myscene = scene;
 
  //初始化1117
  tsj_1117.obj = scene.getObjectByName("1117_TSJ");
  tsj_1117.obj.children[1].position.set(tsj_1117.obj.children[1].position.x, 4.45, tsj_1117.obj.children[1].position.z);
  //初始化1113
  tsj_1113.obj = scene.getObjectByName("1113_TSJ");
  tsj_1113.obj.children[1].position.set(tsj_1117.obj.children[1].position.x, 4.45, tsj_1117.obj.children[1].position.z);

  //初始化1109
  tsj_1109.obj = scene.getObjectByName("1109_TSJ");
  tsj_1109.obj.children[1].position.set(tsj_1117.obj.children[1].position.x, 4.45, tsj_1117.obj.children[1].position.z);

  //初始化1074
  jbj_1074.obj = scene.getObjectByName("1074_JBJ_Left");
  jbj_1074.obj.children[2].children[0].position.set(1.921, -1.3, 0);
  jbj_1074.obj.children[2].children[0].children[0].position.set(jbj_1074.obj.children[2].children[0].children[0].position.x, jbj_1074.obj.children[2].children[0].children[0].position.y, -0.665);
  jbj_1074.obj.children[2].children[0].children[1].position.set(jbj_1074.obj.children[2].children[0].children[1].position.x, jbj_1074.obj.children[2].children[0].children[1].position.y, 0.702);


  //初始化1004
  jbj_1004.obj = scene.getObjectByName("1004_JBJ");
  var whole = jbj_1004.obj.children[0].children[0];
  whole.position.set(1.862, -1.208, whole.position.z);

  //初始化1074
  jbj_1074.obj = scene.getObjectByName("1074_JBJ_Left");
  jbj_1074.obj.children[2].children[0].position.set(1.921, -1.3, 0);
  jbj_1074.obj.children[2].children[0].children[0].position.set(jbj_1074.obj.children[2].children[0].children[0].position.x, jbj_1074.obj.children[2].children[0].children[0].position.y, -0.665);
  jbj_1074.obj.children[2].children[0].children[1].position.set(jbj_1074.obj.children[2].children[0].children[1].position.x, jbj_1074.obj.children[2].children[0].children[1].position.y, 0.702);
  //初始化拆垛机
  cdj_1002.obj = scene.getObjectByName("1002_JBJ_DGW");
  cdj_1002.obj.children[0].position.set(0, 1.825, 0);



}
export { Init_Device_pos }
//设置箱子
const SetBox = function (device_number, _box) {

  switch (device_number) {

    case "1074":

      if (jbj_1074.box != null) {
        jbj_1074.cacheBox = _box;


      } else {
        jbj_1074.box = _box;

      }

      break;
    case "1004":
      if (jbj_1004.box != null) {
        jbj_1004.cacheBox = _box;
      } else {
        jbj_1004.box = _box;
      }

      break;
    case "1002":
      
      cdj_1002.cacheBox = _box;
      cdj_1002.box = _box.children[1];
      

      break;
    case "1113":
      if (tsj_1113.box != null) {
        tsj_1113.cacheBox = _box;
      } else {
        tsj_1113.box = _box;
      }

      break;
    case "1117":
      if (tsj_1117.box != null) {
        tsj_1117.cacheBox = _box;
      } else {
        tsj_1117.box = _box;
      }

      break;
    case "1109":
      if (tsj_1109.box != null) {
        tsj_1109.cacheBox = _box;
      } else {
        tsj_1109.box = _box;
      }

      break;
    case "1077":

      if (tsj_1077.box != null) {
        tsj_1077.cacheBox = _box;
        //console.log("设置箱子了1077")
      } else {
        tsj_1077.box = _box;
        //console.log("设置箱子了")
      }



      break;
  }
}

export { SetBox }

//输送机动作处理
const Convery_action_handle = function (message) {


}
export { Convery_action_handle }

//输送机任务处理
const Convery_task_handle = function (message) {

}
export { Convery_task_handle }

window.ss_1006_box = null;





// WEBPACK FOOTER //
// ./src/components/xiayan/home/Device.js